//core
import React, { useContext, useState, useEffect, useCallback } from "react";
import arePropsEqual from "react-fast-compare";
import { makeStyles } from "@mui/styles";
import { Box, Checkbox, useMediaQuery } from "@mui/material";

//context
import { TrackersContext } from "../../../../admin/Partners/PartnerAccount/TrackerList/TrackersContext";

//components
import ClickableTrackerId from "../ClickableTrackerId";

//types
import { itemListData } from "../../index";

interface IText {
  value: string | number;
  data: itemListData;
  setSelectedRow: (state: boolean) => void;
}

const useStyles = makeStyles({
  block: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  text: {
    color: 'inherit',
    display: 'flex',
    alignItems: 'center',
  }
});

const SelectedTrackersDealsRow = ({
  value = '',
  data,
  setSelectedRow,
}: IText) => {
  const styles = useStyles();
  const context = useContext(TrackersContext);
  const mobile = useMediaQuery('(max-width:767px)');

  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(context.selectedTrackers.some((item: any) => `${item.id}` === `${data.id}`));
  }, [context.selectedTrackers, data.id]);

  useEffect(() => {
    if (checked) {
      setSelectedRow(true);
    } else {
      setSelectedRow(false);
    }
  }, [checked]);

  const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const selected: itemListData = data;

    if (event.target.checked) {
      context.addSelectedTrackers(selected);
    } else {
      const filtered = context.selectedTrackers.filter(item => {
        return item.id !== selected.id
      });
      context.setSelectedTrackers(filtered)
    }

    setChecked(event.target.checked);
  }, [data, setChecked, context.selectedTrackers]);

  return (
    <Box
      component="span"
      className={styles.block}
    >
      <Checkbox
        size="small"
        sx={{ padding: '4px' }}
        checked={checked}
        onChange={handleChange}
        inputProps={{ 'aria-label': 'controlled' }}
      />
      <span className={styles.text}>
        {mobile && `ID `}
        {value ? <ClickableTrackerId value={value} /> : '—'}
      </span>
    </Box>
  );
};

export default React.memo(SelectedTrackersDealsRow, arePropsEqual);
